import React from "react";
import ReactDOM from "react-dom/client"; // ✅ React 18에서 사용
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { ApplicationCommonProvider } from "./utils/ApplicationCommon"; // ✅ 공통 기능 Provider 추가

// ✅ React 18 방식의 루트 생성
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <ApplicationCommonProvider> {/* ✅ 공통 Provider 적용 */}
      <App />
    </ApplicationCommonProvider>
  </HelmetProvider>
);
